import { render } from "./PmFooter.vue?vue&type=template&id=6161e3e2&scoped=true"
import script from "./PmFooter.vue?vue&type=script&lang=js"
export * from "./PmFooter.vue?vue&type=script&lang=js"

import "./PmFooter.vue?vue&type=style&index=0&id=6161e3e2&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6161e3e2"]])

export default __exports__